import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from '@cotyorg/ccx-molecules/Accordion';
import MobileNavigationVerticalList from './MobileNavigationVerticalList';
import MobileNavigationVerticalLink from './MobileNavigationVerticalLink';

const hasNestedPages = page => !!page.pages.filter(nestedPage => nestedPage.pages && nestedPage.pages.length).length;

const MobileNavigationVerticalAccordion = ({
  pages,
  openAccordionButtonExtraClass,
  accordionBodyExtraClass,
  minusIconSrc,
  plusIconSrc,
  navigationLinkIconWidth,
  navigationLinkIconHeight,
}) => {
  if (!Array.isArray(pages)) {
    return null;
  }

  return (
    <Accordion>
      {
        pages.map((page) => {
          if (!page.pages || !page.pages.length) {
            return (
              <MobileNavigationVerticalLink
                key={page.slug}
                name={page.name}
                pages={page.pages}
                url={page.url}
                openInNewWindow={page.openInNewWindow}
                isTopLevel
              />
            );
          }

          const hasNestedAccordion = hasNestedPages(page);
          const combinedPages = R.concat(page.pages, R.propOr([], 'morePages', page));

          return (
            <AccordionItem key={page.slug}>
              <AccordionItemTitle
                buttonExtraClass="mobile-navigation__link mobile-navigation-vertical__link--top-level"
                textExtraClass="mobile-navigation-vertical__link-text"
                openIndicatorExtraClass="mobile-navigation-vertical__link-open-indicator"
                openButtonExtraClass={openAccordionButtonExtraClass}
                minusIconSrc={minusIconSrc}
                plusIconSrc={plusIconSrc}
                iconWidth={navigationLinkIconWidth}
                iconHeight={navigationLinkIconHeight}
              >
                { page.name }
              </AccordionItemTitle>
              <AccordionItemBody extraClass={accordionBodyExtraClass} >
                { hasNestedAccordion &&
                  <MobileNavigationVerticalAccordion
                    minusIconSrc={minusIconSrc}
                    plusIconSrc={plusIconSrc}
                    pages={combinedPages}
                  />
                }
                { !hasNestedAccordion && (
                  <MobileNavigationVerticalList pages={combinedPages} />
                )}
              </AccordionItemBody>
            </AccordionItem>
          );
        })
      }
    </Accordion>
  );
};

MobileNavigationVerticalAccordion.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    pages: PropTypes.array,
    morePages: PropTypes.array,
    openInNewWindow: PropTypes.bool,
  })),
  openAccordionButtonExtraClass: PropTypes.string,
  accordionBodyExtraClass: PropTypes.string,
  plusIconSrc: PropTypes.string,
  minusIconSrc: PropTypes.string,
  navigationLinkIconWidth: PropTypes.number,
  navigationLinkIconHeight: PropTypes.number,
};

export default MobileNavigationVerticalAccordion;
